import axios from "axios";
export async function get(url) {
  try {
    const token = sessionStorage.getItem("token");
    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

export async function post(url, data) {
  try {
    const token = sessionStorage.getItem("token");
    const response = await axios.post(url, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}
export async function upload(url, data) {
  try {
    const token = sessionStorage.getItem("token");
    const response = await axios.post(url, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

export async function put(url, data) {
  try {
    const token = sessionStorage.getItem("token");
    const response = await axios.put(url, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating data:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}
export async function del(url) {
  try {
    const token = sessionStorage.getItem("token");
    const response = await axios.delete(url, {
      headers: {
        Accept: "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting data:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}
